import React from 'react';
import { bool, func } from 'prop-types';
import Button from '@material-ui/core/Button';

import edpLogoLarge from '../../edp-small.png';

const CompareButton = ({ disabled, onClick, inline }) => (
  <Button
    id="compare-button"
    color="primary"
    variant="raised"
    disabled={disabled}
    onClick={onClick}
    style={
      inline
        ? { height: 48, fontSize: 18, padding: '0 28px', flexShrink: 0, textTransform: 'none' }
        : { height: 48, fontSize: 18, position: 'absolute', bottom: 0 }
    }
  >
    <img
      alt="ExamDiff Pro"
      src={edpLogoLarge}
      width={24}
      height={24}
      style={{
        marginRight: 10,
        filter: disabled ? 'grayscale(100%)' : 'none'
      }}
    />
    Compare
  </Button>
);

CompareButton.propTypes = {
  disabled: bool,
  onClick: func,
  inline: bool
};

export default CompareButton;
